/* tslint:disable */
/* eslint-disable */
/**
 * Zalaris Benchmarks Task Orchestration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface ErrorEntry {
    'code'?: string;
    'message'?: string;
}
/**
 * Generic error envelope used across services
 */
export interface ErrorResponse {
    'status'?: number;
    'timestamp'?: string;
    'path'?: string;
    'errors'?: Array<ErrorEntry>;
}
export interface TaskCreateRequest {
    'type': TaskType;
    /**
     * Task-specific parameters (opaque to the orchestration API). Examples: - sf_position_import: { top: 500, mongoFilters: [...] } - ai_enrichment: { ids: [\"pos-1\"], providers: [\"ai\"], contexts: { ai: {...} } } - benchmark_generate: { ids: [\"pos-1\"], providers: [\"ai\"], contexts: { ai: {...} } } - benchmark_upload: { ids: [\"bench-1\"], onlyUpdatedRecords: true } 
     */
    'payload'?: { [key: string]: any; } | null;
}


export interface TaskCreateResponse {
    'taskId': string;
}
/**
 * Progress snapshot for a task
 */
export interface TaskProgress {
    /**
     * Number of items processed so far
     */
    'processed'?: number;
    /**
     * Optional total number of items to process (if known)
     */
    'total'?: number | null;
    /**
     * Current stage or sub-step description
     */
    'stage'?: string;
    /**
     * Optional percent complete if calculable
     */
    'percent'?: number | null;
}
/**
 * Point-in-time view of a task
 */
export interface TaskSnapshot {
    'id': string;
    'type': TaskType;
    /**
     * Opaque payload supplied when the task was created
     */
    'payload'?: { [key: string]: any; };
    'status': TaskStatus;
    /**
     * Whether cancellation has been requested
     */
    'cancelRequested': boolean;
    'progress'?: TaskProgress;
    /**
     * Error message when status is FAILED
     */
    'error'?: string;
    /**
     * Human-readable task title (stable identifier)
     */
    'title'?: string | null;
    /**
     * Human-readable task description (may update during execution)
     */
    'description'?: string | null;
    'createdAt': string;
    'startedAt'?: string | null;
    'finishedAt'?: string | null;
    /**
     * User who created the task
     */
    'createdBy'?: string | null;
    /**
     * User who last updated the task (e.g., cancelled it)
     */
    'updatedBy'?: string | null;
}


/**
 * Current state of the task
 */

export const TaskStatus = {
    Queued: 'QUEUED',
    Running: 'RUNNING',
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED',
    Canceled: 'CANCELED'
} as const;

export type TaskStatus = typeof TaskStatus[keyof typeof TaskStatus];


/**
 * Task type identifier
 */

export const TaskType = {
    SfPositionImport: 'sf_position_import',
    AiEnrichment: 'ai_enrichment',
    BenchmarkGenerate: 'benchmark_generate',
    BenchmarkUpload: 'benchmark_upload'
} as const;

export type TaskType = typeof TaskType[keyof typeof TaskType];



/**
 * TasksApi - axios parameter creator
 */
export const TasksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Sets a cancelRequested flag. Task handlers stop at the next safe checkpoint. No rollback is performed. 
         * @summary Request cooperative cancellation of a task
         * @param {string} taskId Task identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTask: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('cancelTask', 'taskId', taskId)
            const localVarPath = `/api/tasks/{taskId}/cancel`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a long-running task (e.g., SuccessFactors import, enrichment, benchmark generation, benchmark upload). Returns task identifier 
         * @summary Enqueue a new asynchronous task
         * @param {TaskCreateRequest} taskCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask: async (taskCreateRequest: TaskCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskCreateRequest' is not null or undefined
            assertParamExists('createTask', 'taskCreateRequest', taskCreateRequest)
            const localVarPath = `/api/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(taskCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get latest task snapshot
         * @param {string} taskId Task identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getTask', 'taskId', taskId)
            const localVarPath = `/api/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all known tasks with their latest snapshots.
         * @summary List tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTasks: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TasksApi - functional programming interface
 */
export const TasksApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TasksApiAxiosParamCreator(configuration)
    return {
        /**
         * Sets a cancelRequested flag. Task handlers stop at the next safe checkpoint. No rollback is performed. 
         * @summary Request cooperative cancellation of a task
         * @param {string} taskId Task identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelTask(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskSnapshot>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelTask(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.cancelTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts a long-running task (e.g., SuccessFactors import, enrichment, benchmark generation, benchmark upload). Returns task identifier 
         * @summary Enqueue a new asynchronous task
         * @param {TaskCreateRequest} taskCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTask(taskCreateRequest: TaskCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTask(taskCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.createTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get latest task snapshot
         * @param {string} taskId Task identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTask(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskSnapshot>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTask(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.getTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all known tasks with their latest snapshots.
         * @summary List tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTasks(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskSnapshot>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTasks(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TasksApi.listTasks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TasksApi - factory interface
 */
export const TasksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TasksApiFp(configuration)
    return {
        /**
         * Sets a cancelRequested flag. Task handlers stop at the next safe checkpoint. No rollback is performed. 
         * @summary Request cooperative cancellation of a task
         * @param {string} taskId Task identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTask(taskId: string, options?: RawAxiosRequestConfig): AxiosPromise<TaskSnapshot> {
            return localVarFp.cancelTask(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a long-running task (e.g., SuccessFactors import, enrichment, benchmark generation, benchmark upload). Returns task identifier 
         * @summary Enqueue a new asynchronous task
         * @param {TaskCreateRequest} taskCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTask(taskCreateRequest: TaskCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskCreateResponse> {
            return localVarFp.createTask(taskCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get latest task snapshot
         * @param {string} taskId Task identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(taskId: string, options?: RawAxiosRequestConfig): AxiosPromise<TaskSnapshot> {
            return localVarFp.getTask(taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all known tasks with their latest snapshots.
         * @summary List tasks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTasks(options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskSnapshot>> {
            return localVarFp.listTasks(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TasksApi - object-oriented interface
 */
export class TasksApi extends BaseAPI {
    /**
     * Sets a cancelRequested flag. Task handlers stop at the next safe checkpoint. No rollback is performed. 
     * @summary Request cooperative cancellation of a task
     * @param {string} taskId Task identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cancelTask(taskId: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).cancelTask(taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a long-running task (e.g., SuccessFactors import, enrichment, benchmark generation, benchmark upload). Returns task identifier 
     * @summary Enqueue a new asynchronous task
     * @param {TaskCreateRequest} taskCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTask(taskCreateRequest: TaskCreateRequest, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).createTask(taskCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get latest task snapshot
     * @param {string} taskId Task identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTask(taskId: string, options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).getTask(taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all known tasks with their latest snapshots.
     * @summary List tasks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listTasks(options?: RawAxiosRequestConfig) {
        return TasksApiFp(this.configuration).listTasks(options).then((request) => request(this.axios, this.basePath));
    }
}



